import React from 'react';
import { Menu, Maximize2, ChevronDown, LogOut, User as UserIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const pageTitles = {
  '/panoramica': 'PANORAMICA',
  '/aziende': 'ELENCO AZIENDE',
  '/lavoratori': 'LAVORATORI',
  '/formazione': 'FORMAZIONE',
  '/sorveglianza': 'SORVEGLIANZA SANITARIA',
  '/dpi': 'DPI',
  '/haccp': 'HACCP',
  '/sicurezza': 'SICUREZZA SUL LAVORO',
  '/calendario': 'CALENDARIO',
  '/comunicazioni': 'COMUNICAZIONI',
  '/report': 'REPORT',
  '/migrazione': 'MIGRAZIONE DATI',
};

const TopBar = ({ onToggleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const title = pageTitles[location.pathname] || '';
  const subtitle = user?.role === 'client' ? user?.name?.toUpperCase() : 'CENTRO SICUREZZA CONSULENZE';

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      {/* Top white bar */}
      <header className="h-14 bg-white border-b border-gray-200 flex items-center px-4 sticky top-0 z-30">
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-md hover:bg-gray-100 transition-colors"
          aria-label="Toggle menu"
        >
          <Menu size={20} className="text-gray-700" />
        </button>

        <div className="flex-1" />

        <div className="flex items-center gap-1">
          <button
            onClick={handleFullscreen}
            className="hidden sm:inline-flex p-2 rounded-md hover:bg-gray-100 transition-colors text-gray-500"
            title="Schermo intero"
            data-testid="topbar-fullscreen"
          >
            <Maximize2 size={18} />
          </button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="ml-2 flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors" data-testid="topbar-user-menu">
                <div className="w-8 h-8 rounded-full bg-[#023F80] text-white flex items-center justify-center text-xs font-bold">
                  {(user?.name || 'U').charAt(0)}
                </div>
                <span className="hidden xl:inline text-sm font-semibold text-gray-800 tracking-wide max-w-[200px] truncate">
                  {subtitle}
                </span>
                <ChevronDown size={14} className="text-gray-500" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="text-xs text-gray-500 font-normal">Accesso come</div>
                <div className="text-sm font-semibold">{user?.name}</div>
                <div className="text-[11px] mt-1 inline-block px-2 py-0.5 rounded-full bg-[#e0e7ff] text-[#001E42]">
                  {user?.role === 'client' ? 'Cliente' : 'Consulente'}
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem>
                <UserIcon size={14} className="mr-2" /> Profilo
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleLogout} className="text-red-600 focus:text-red-700" data-testid="topbar-logout">
                <LogOut size={14} className="mr-2" /> Esci
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </header>

      {/* Dark breadcrumb */}
      <div className="bg-[#023F80] text-white px-4 sm:px-6 py-2.5 text-[11px] sm:text-xs tracking-wider font-semibold flex items-center gap-2 overflow-hidden">
        <span className="truncate">{title}</span>
        {subtitle && (
          <>
            <span className="text-white/30">/</span>
            <span className="text-[#FFCB05] truncate">{subtitle}</span>
          </>
        )}
      </div>
    </>
  );
};

export default TopBar;
